// Domain enums mirrored from Backend Domain/Enums/Enums.cs. Used by shared display components
// (RiskBadge, ScoreBadge, status tags). Kept as string-literal unions to match EF's string storage.

export type RiskLevel = 'Low' | 'Medium' | 'High';

export type ProcessingStatus =
  | 'Received'
  | 'Processing'
  | 'Processed'
  | 'Error'
  | 'RequiresReprocessing';

export type HumanReviewStatus = 'Pending' | 'Reviewed';

export const RISK_LABELS: Record<RiskLevel, string> = {
  Low: 'کم',
  Medium: 'متوسط',
  High: 'زیاد',
};
